/* same.icon.svg.js */

module.exports = {
    icon: `    
            <svg viewBox="0 0 24 16" preserveAspectRatio="none">
            <style type="text/css">
                .st0{fill:#1A1A1A;}
            </style>
            <path class="foreground-gl" d="M8,16c-4.4,0-8-3.6-8-8s3.6-8,8-8s8,3.6,8,8S12.4,16,8,16z M8,0.9C4.1,0.9,0.9,4.1,0.9,8s3.2,7.1,7.1,7.1
                s7.1-3.2,7.1-7.1S11.9,0.9,8,0.9z"/>
            <path class="foreground-gl" d="M16,16c-4.4,0-8-3.6-8-8s3.6-8,8-8s8,3.6,8,8S20.4,16,16,16z M16,0.9c-3.9,0-7.1,3.2-7.1,7.1s3.2,7.1,7.1,7.1
                s7.1-3.2,7.1-7.1S19.9,0.9,16,0.9z"/>
            </svg>
         `
};
